import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { VALUE_PROPS } from './smb-beta-data';

const SMBBetaBenefits = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6">
            {VALUE_PROPS.map(({ icon: Icon, key }) => (
              <div
                key={key}
                className="bg-white border border-slate-200 rounded-lg p-6 hover:border-primary/30 transition-colors"
              >
                <Icon className="w-8 h-8 text-primary mb-4" />
                <h3 className="text-lg font-semibold text-slate-900 mb-2">
                  {t(`smb.valueProps.${key}.title`)}
                </h3>
                <p className="text-slate-600">
                  {t(`smb.valueProps.${key}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto bg-slate-50 border border-slate-200 rounded-xl p-8">
          <h2 className="text-2xl font-bold text-slate-900 mb-6 text-center">
            {t('smb.differentiation.title')}
          </h2>
          <div className="space-y-4">
            <div className="flex items-start space-x-3">
              <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-slate-900">{t('smb.differentiation.notClutch')}</p>
                <p className="text-sm text-slate-600">{t('smb.differentiation.notClutchDesc')}</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-slate-900">{t('smb.differentiation.notGeneric')}</p>
                <p className="text-sm text-slate-600">{t('smb.differentiation.notGenericDesc')}</p>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-slate-900">{t('smb.differentiation.notConsultants')}</p>
                <p className="text-sm text-slate-600">{t('smb.differentiation.notConsultantsDesc')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SMBBetaBenefits;
